module.exports = __webpack_public_path__ + "media/images/logo-018129e87e1edd365c945c8950b9349b.png";